import { render, staticRenderFns } from "./addOTADrawer.vue?vue&type=template&id=8f71d158&scoped=true"
import script from "./addOTADrawer.vue?vue&type=script&lang=js"
export * from "./addOTADrawer.vue?vue&type=script&lang=js"
import style0 from "./addOTADrawer.vue?vue&type=style&index=0&id=8f71d158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f71d158",
  null
  
)

export default component.exports